import { service } from ".";

export default {
  getAll: () => service.get("/blogs"),
  getOne: (id) => service.get(`/blogs/${id}`),
  getAllPaginate: (query) => service.get(`/blogs/paginate?${query}`),
  create: (data) => service.post("/blogs", data),
  update: (id, data) => service.put(`/blogs/${id}`, data),
  achive: (id) => service.put(`/blogs/arxiv/${id}`),
  delete: (id) => service.delete(`/blogs/${id}`),
};
